import { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { http } from '../helper';
import { BaseUrl } from '../common/config';
import DatePicker from "react-datepicker";
import { format } from 'date-fns';
import Popup from "../common/popup";
import { dateformatwithuktime } from "../utilityfunctions";
export const CustomerFirstOrders = ({ }) => {

    const priceFormat = (price) => {
        return price.toLocaleString("en-US", {
            style: "currency",
            currency: "GBP",
            minimumFractionDigits: 2,
        });
    };

    const getAdjustedOnboardedDate = (account) => {
        if (!account?.accountCreatedAt) return "";
        const originalDate = new Date(account.accountCreatedAt);
        const comparisonDate = new Date("2024-09-02");
        const chosenDate = originalDate < comparisonDate ? comparisonDate : originalDate;
        return formatDate(chosenDate);
    };

    const getAdjustedActivatedDate = (account) => {
        if (!account) return "";
        const originalDate = account.recentActivatedDate
            ? new Date(account.recentActivatedDate)
            : account.accountCreatedAt
                ? new Date(account.accountCreatedAt)
                : null;
        if (!originalDate) return "";
        const comparisonDate = new Date("2024-09-02");
        const chosenDate = originalDate < comparisonDate ? comparisonDate : originalDate;
        return formatDate(chosenDate);
    };

    const columns = [
        {
            name: "Account Code",
            selector: row => row.accountCode,
            sortable: false,
        },
        {
            name: "Account Name",
            selector: row => row.accountName,
            sortable: false,
        },

        {
            name: "Date Onboarded",
            selector: row => row.orderCreatedAt,
            cell: row => getAdjustedOnboardedDate(row),
        },
        {
            name: "Activated Date (Before First Order)",
            selector: row => row.recentActivatedDate || row.accountCreatedAt,
            cell: row => {
                const displayDate = getAdjustedActivatedDate(row);
                return displayDate ? (
                    <a
                     className='button'
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            handleActivatedDateClick(row.accountCode);
                        }}
                    >
                        {displayDate}
                    </a>
                ) : "";
            },
            sortable: true,
        },
        {
            name: "Ordered Date",
            selector: row => new Date(row.orderCreatedAt),
            //cell: row => formatDate(row.orderCreatedAt),   // for display as "DD/MM/YYYY"
            cell: row => {
                if (!row.orderCreatedAt) return '';
                const originalDate = new Date(row.orderCreatedAt);
                const comparisonDate = new Date('2024-09-02');
                const displayDate = originalDate < comparisonDate ? comparisonDate : originalDate;
                return formatDate(displayDate);
            },
            sortable: true,
        },        
       
        {
            name: "Ordered Amount",
            selector: row => row?.OrderTotalWithVat ? priceFormat(row.OrderTotalWithVat): 0,
            sortable: false,
        },
       
    ];

    const customStyles = {
        rows: {
            style: {
                minHeight: '25px',
            },
        },
        headCells: {
            style: {
                padding: '8px', // override the cell padding for head cells

            },
        },
        cells: {
            style: {
                padding: '8px', // override the cell padding for data cells

            },
        },
    };

    const paginationComponentOptions = {
        rowsPerPageText: "",
        rangeSeparatorText: "",
        selectAllRowsItem: true,
        selectAllRowsItemText: "",
        noRowsPerPage: "",
    };
     
    var currentTime = new Date();
    var currentyear = currentTime.getFullYear();
    var currentMonth = currentTime.getUTCMonth() + 1;
    const [filter, setFilter] = useState(0);
    const [filtertext, setFilterText] = useState('');
    const [firstCustomerOrders, setFirstCustomerOrders] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [popupLogView, setPopupLogView] = useState(null); // Stores the Popup component
    const [accountLogs, setAccountLogs] = useState([]); // Stores fetched logs for selected account
    const [accountCode, setAccountCode] = useState(""); // Stores the account code clicked
    const [isLoadingLogs, setIsLoadingLogs] = useState(false); // Loading state while fetching logs
    const getCurrentFiscalYear = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth() + 1;
        // Fiscal year starts in September
        const startYear = month >= 9 ? year : year - 1;
        const endYear = startYear + 1;
        return `${startYear}-${endYear}`;
    };
    const [period, setPeriod] = useState(getCurrentFiscalYear());
    const [FilterType, setFilterType] = useState("revenue");
    const [allCustomers, setAllCustomers] = useState([]); // Store full unfiltered records
    const [months, setMonths]=useState(9);
    const [quarter,setQuarter]=useState('');

    const MonthNames = ["Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"];
    const currentFiscalMonth = new Date().getMonth(); // 0-indexed: Jan = 0, Apr = 3, Sep = 8
    const quarterNames = {
        1: "Sep - Nov",
        2: "Dec - Feb",
        3: "Mar - May",
        4: "Jun - Aug"
    };
    const getCurrentFiscalQuarter = () => {
        const month = new Date().getMonth() + 1; // 1–12
        if (month >= 9 && month <= 11) return 1;   // Sep–Nov
        if (month === 12 || month <= 2) return 2;  // Dec–Feb
        if (month >= 3 && month <= 5) return 3;    // Mar–May
        return 4;                                  // Jun–Aug
    };

    const getAvailableQuarters = (selectedFiscalYear) => {
        const currentFiscalYear = getCurrentFiscalYear();
        const currentQuarter = getCurrentFiscalQuarter();

        return Object.entries(quarterNames)
        .filter(([quarterNumber]) => {
        if (selectedFiscalYear === currentFiscalYear) {
            return Number(quarterNumber) <= currentQuarter;
        }
        return true; // show all for past years
        })
        .map(([quarterNumber, label]) => (
        <option key={quarterNumber} value={quarterNumber}>
            {label}
        </option>
        ));
    };
    useEffect(() => {
        const now = new Date();
        const month = now.getMonth() + 1;
        const fiscalQuarterMap = {
          9: 1, 10: 1, 11: 1,
          12: 2, 1: 2, 2: 2,
          3: 3, 4: 3, 5: 3,
          6: 4, 7: 4, 8: 4
        };
        const currentFiscalQuarter = fiscalQuarterMap[month];
        setQuarter(currentFiscalQuarter);
    }, []);

    const handleActivatedDateClick = (code) => {
        setAccountCode(code);
        setIsLoadingLogs(true);
        http.get(BaseUrl + "admin/accountlog/" + code)
            .then(response => {
                setAccountLogs(response.data.data);
                setIsLoadingLogs(false);
                setPopupLogView(true); // Show the popup
            })
            .catch(err => {
                setAccountLogs([]);
                setIsLoadingLogs(false);
                setPopupLogView(true); // show popup with No logs available
            });
    };

    useEffect(() => {
        if (filter === "custom" && (!fromDate || !toDate)) {
            // Don't make the API call if dates are missing for the "custom" filter
            return;
        }
        setIsLoading(true);
        let payload = {};
        if (filter === 'custom') {
            payload = {
                filter: filter, datefrom: format(new Date(fromDate), "yyyy-MM-dd"),
                dateto: format(new Date(toDate), "yyyy-MM-dd"),
                //FilterType: FilterType
            }
            setShowDatePicker(false);
        }
        else if (filter ==="weekly"){
              payload = {
                    filter: "weekly",
                }; 
        }
        else if (["monthly", "quarterly","FYdata"].includes(filter)) 
        {
            payload = {
                filter: filter,
                datefrom: "",
                dateto: "",
                period: period,
            }; 
            if(filter==='quarterly'){
                //console.log(quarter)
                payload.value = Number(quarter);
            }
            else if(filter==='monthly'){
                payload.value = Number(months);
            }
        }
        else {
            payload = {
                filter: parseInt(filter), datefrom: '',
                dateto: '',
            }
        }
        let URL2 = BaseUrl + "admin/customerFirstOrderDetail";
        http.post(URL2, payload).then((response) => {
            setIsLoading(false);
            //console.log(response);
            const data = response.data.data;
            const sortedData = [...data].sort(
                (a, b) => new Date(b.orderCreatedAt).getTime() - new Date(a.orderCreatedAt).getTime()
                );
            setFirstCustomerOrders(sortedData);
        }).catch((err) => {
             setIsLoading(false);
            console.log(err);
        })

    }, [filter, fromDate, toDate, FilterType, months, quarter,period]);
    
    const changeFilterHandler = (e) => {

        setFilter(e.target.value);
        setFilterText(e.target.options[e.target.selectedIndex].text);
        if (e.target.value === 'custom') {
            setShowDatePicker(true);
        } else {
            setShowDatePicker(false);
            setFromDate(null);
            setToDate(null);
            setFilter(e.target.value);
        }
    };

    const changePeriodHandler = (e) => {
        const newPeriod = e.target.value;
        setPeriod(newPeriod); // update selected fiscal year in state
        //split fiscal year
        const [newStartYear, newEndYear] = newPeriod.split('-').map(Number);
        
        const fiscalStartMonthIndex = 8; // 0-based index for September

        const today = new Date();
        const currentFiscalYear = getCurrentFiscalYear();
        //compare sleted year with currentfiscalyear 
        const isCurrentFiscalYear = newPeriod === currentFiscalYear;

        // MONTHLY filter logic
        if (filter === 'monthly') {
            let visibleMonthNames = MonthNames;

            if (isCurrentFiscalYear) {
            // Calculate current fiscal month index 
            const currentMonthIndex = today.getMonth(); // 0-based
            const monthsPassedSinceFiscalStart =
                (currentMonthIndex - fiscalStartMonthIndex + 12) % 12;
            const maxVisibleIndex = monthsPassedSinceFiscalStart;

            visibleMonthNames = MonthNames.slice(0, maxVisibleIndex + 1);
            }

            const selectedMonthIndex = MonthNames.indexOf(months);
            const isValidMonth =
            selectedMonthIndex >= 0 && selectedMonthIndex < visibleMonthNames.length;

            if (!isValidMonth) {
            const defaultMonthNumber = ((0 + fiscalStartMonthIndex) % 12) + 1;
            setMonths(String(defaultMonthNumber));
            }
        }

        // QUARTERLY filter logic
        if (filter === 'quarterly') {
            const currentQuarter = getCurrentFiscalQuarter();
            let maxQuarter = 4;

            if (isCurrentFiscalYear) {
            maxQuarter = currentQuarter;
            }

            if (parseInt(quarter) > maxQuarter) {
            setQuarter(maxQuarter > 0 ? String(maxQuarter) : "1");
            }

        }
    };

    const changeMonthHandler = (e) => {
        setMonths(e.target.value);
    };
    
    const formatDate = (dateString) => {
        const dateObject = new Date(dateString);
        const year = dateObject.getFullYear();
        const month = String(dateObject.getMonth() + 1).padStart(2, "0");
        const day = String(dateObject.getDate()).padStart(2, "0");
        return `${day}/${month}/${year}`;
    }

    const DateChange = (value, type) => {
        if (type === "from") {
            setFromDate(value);

            if (toDate && value && value > toDate) {
                setToDate(null);
            }
        } else if (type === "to") {
            if (!fromDate || value >= fromDate) {
                setToDate(value);
            } else {
                // Handle invalid date selection
                //alert("The 'To' date cannot be earlier than the 'From' date.");
                setToDate(null);
            }
        }
    };

    // Calculate dynamic pagination options
    const calculatePaginationOptions = (totalRecords, interval) => {
        const options = [];
        for (let i = interval; i <= totalRecords; i += interval) {
            options.push(i);
        }
        return options;
    };

    const totalRecords = firstCustomerOrders.length; // Get the total records count
    const paginationOptions = calculatePaginationOptions(totalRecords, 10); // Generate options with interval of 10
    const options = [];

    for (let i = currentyear; i >= 2023; i--) {
        if (i === currentyear && currentMonth < 9) {
            continue;
          }
        const year = i;
        options.push(
            <option value={year + "-" + (year + 1)}>{year + "-" + (year + 1)}</option>
        );
    }

    const currentFiscalYear = getCurrentFiscalYear();
    let visibleMonthNames = MonthNames;
    if (period === currentFiscalYear) {
    // Limit to current fiscal month
    const fiscalIndex = (new Date().getMonth() - 8 + 12) % 12; // Sep=0, Oct=1, ... Aug=11
    visibleMonthNames = MonthNames.slice(0, fiscalIndex + 1);
    }
    let loadingbuffer = isLoading ? 'loading-buffer' : '';
    return (
        <div className={`chart-container cust-first-orders ${loadingbuffer}`} style={{ verticalAlign: "top" }}>
            <div className="chart-Hdr">
                <div className="chart-Hdr-txt">
                    <h2>First-Time Customer Order</h2>
                </div>
                {/* New Sort Filter Dropdown */}
                <div className="chart-fltr-Hldr">
            
                <div className="chart-fltr" onMouseEnter={() => {
                    if (filter === "custom" && !showDatePicker) {
                        setShowDatePicker(true);
                    }
                }}
                    onMouseLeave={() => {
                        if (filter === "custom" && showDatePicker) {
                            setShowDatePicker(false);

                        }
                    }}>
                    {<select
                        value={filter}
                        onChange={(e) => changeFilterHandler(e)}
                    ><option value={0}>All</option>
                        <option value={"weekly"}>Current Week</option>
                        <option value={"monthly"}>Monthly</option>
                        <option value={"quarterly"}>Quarterly</option>
                        <option value={"FYdata"}>FY Data</option>
                        <option value={30}>Past 30 Days</option>
                        <option value={90}>Past 90 Days</option>
                        <option value={180}>Past 180 Days</option>
                        <option value={365}>Past 1 Year</option>
                        <option value={'custom'}>Custom Date</option>
                    </select>}
                    {showDatePicker && (
                        <div className="date-picker-container">
                            <label>From:</label>
                            <DatePicker
                                selected={fromDate}
                                onChange={(date) => DateChange(date, "from")}
                                showDisabledMonthNavigation
                                dateFormat="dd/MM/yyyy"
                                disablePast={true}
                                maxDate={new Date()}
                                placeholderText="Select Date"
                            />
                            <label>To:</label>
                            <DatePicker
                                selected={toDate}
                                showDisabledMonthNavigation
                                dateFormat="dd/MM/yyyy"
                                onChange={(date) => DateChange(date, "to")}
                                disablePast={true}
                                maxDate={new Date()}
                                placeholderText="Select Date"
                            />
                        </div>
                    )}
                    {filter === 'quarterly' && (
                    <select
                        value={quarter}
                        onChange={(e) => setQuarter(Number(e.target.value))}
                    >
                         {getAvailableQuarters(period)}
                    </select>
                    )}

                    {filter === 'monthly' && <select value={months} onChange={(e)=>changeMonthHandler(e)}>
                    {visibleMonthNames.map((monthName, index) => {
                            const monthNumber = ((index + 8) % 12) + 1; // fiscal-to-calendar month number
                            return (
                                <option key={monthNumber} value={monthNumber}>
                                {monthName}
                                </option>
                            );
                            })}
                    </select>

                    }
                    {(filter === 'monthly' || filter === 'quarterly' || filter==='FYdata') &&<select
                        value={period}
                        onChange={(e) => changePeriodHandler(e)}
                    >
                        {options}
                    </select>}
                </div>
                </div>
                <div className="fltr-sub-val">
                    {firstCustomerOrders.length > 0 && (<span className='fltr-val'>Total Records: <strong>{firstCustomerOrders.length}</strong> {(["Current Week", "Monthly", "Quarterly",'FYdata','All'].includes(filtertext)) ? '' : (filtertext != '' && filtertext != 'Custom Date') ? ' ('+filtertext+')' : (filtertext === 'Custom Date' && fromDate && toDate) ? ' ('+ formatDate(fromDate) + ' - ' + formatDate(toDate)+')' : ' ('+'All'+')'}</span>)}
                </div>
            </div>
            <DataTable
                columns={columns}
                data={firstCustomerOrders}
                customStyles={customStyles}
                noDataComponent={<div className='no-records-found'>Sorry, no data found for your filtered search.</div>}
                pagination
                paginationPerPage={10}
                paginationRowsPerPageOptions={[10, 20, 40, 60, 80, 100]}
                //paginationRowsPerPageOptions={paginationOptions}
                paginationComponentOptions={paginationComponentOptions}
            // paginationComponentOptions={{
            //     rowsPerPageText: '', // Hides "Rows per page"
            // }}
            />
            {popupLogView && (
                <Popup
                    extClass="info-poup show"
                    closebtn={<span className="close" onClick={() => setPopupLogView(false)}></span>}
                    headMoreTxt={
                        <div className="order-top">
                            <h4>Customer Status Log Details - {accountCode}</h4>
                        </div>
                    }
                    bodyMoreTxt={
                    <div className="bottom vendor-details acc-log">
                        {isLoadingLogs ? (
                            <div>Loading...</div>
                        ) : (
                            <>
                                {accountLogs && accountLogs.length > 0 && accountLogs.map((log, index) => {
                                    const [action, notes] = log.noteText.split(/-(.+)/);
                                    const status = action.trim() === "activate" ? "Activated" : "Deactivated";

                                    return (
                                        <div key={index} className="info-item">
                                            <div className="info-innr">
                                                <div className="flex-log-hdr">
                                                    <p><span className="labeltxt acn-by">{status}</span></p>
                                                    <div className="hdrlog-rit">
                                                        {log.createdBy && (
                                                            <>
                                                                <span className="log-user">{log.createdBy}</span>
                                                                <span className="log-line">|</span>
                                                            </>
                                                        )}
                                                        <span className="log-date">{dateformatwithuktime(log.createdAt)}</span>
                                                    </div>
                                                </div>
                                                <p>
                                                    <span className="labeltxt log-reason">Reason: </span>
                                                    {notes ? notes.trim() : ""}
                                                </p>
                                            </div>
                                        </div>
                                    );
                                })}
                                {(() => {
                                    const account = firstCustomerOrders.find(acc => acc.accountCode === accountCode);
                                    if (account) {
                                        const onboarded = getAdjustedOnboardedDate(account);
                                        const activated = getAdjustedActivatedDate(account);

                                        return (
                                            <div className="info-item">
                                                <div className="info-innr">
                                                    <p>
                                                        {onboarded === activated
                                                            ? `Onboarded & Activated on (${onboarded})`
                                                            : `Onboarded & Activated on (${onboarded} & ${activated})`}
                                                    </p>
                                                </div>
                                            </div>
                                        );
                                    }
                                    return null;
                                })()}
                            </>
                        )}
                    </div>
                }
                />
            )}
        </div>
    );
};